<script lang="ts">
	import Ripple from '@smui/ripple/styled';

	const manBwImg = '/assets/images/man_bw.png';
	const manImg = '/assets/images/man.png';
	const womanBwImg = '/assets/images/woman_bw.png';
	const womanImg = '/assets/images/woman.png';

	export let female = false;
	export let active = false;
	export let clickable = true;
	export let small = false;

	const getColorImg = () => (female ? womanImg : manImg);
	const getBwImg = () => (female ? womanBwImg : manBwImg);

	$: imgSrc = active ? getColorImg() : getBwImg();
</script>

<button
	use:Ripple={{ ripple: clickable, color: 'primary' }}
	disabled={!clickable}
	class:clickable
	on:click
>
	<img class:small src={imgSrc} alt="Gender icon" />
</button>

<style>
	button {
		border: 0;
		background: none;
		border-radius: 6px;
	}

	@media screen and (min-width: 600px) {
		button {
			padding: 6px;
		}
	}

	.clickable {
		cursor: pointer;
	}

	img {
		width: 64px;
		display: block;
	}

	.small {
		width: 32px;
		margin: 0 -8px;
	}
</style>
